import { useRef } from "react";
import useLandingMotion from "@/hooks/useLandingMotion";
import SiteHeader from "@/components/landing/SiteHeader";
import Hero from "@/components/landing/Hero";
import {
  AgentSection,
  AssistantSection,
  ClientsSection,
  ClosingCta,
  CoachesSection,
  CoachingSection,
  ProofRow,
  SiteFooter,
  TrialStrip,
} from "@/components/landing/Sections";

export default function LandingPage() {
  const rootRef = useRef(null);
  useLandingMotion(rootRef);

  return (
    <div id="top" ref={rootRef} className="min-h-screen overflow-x-clip bg-white text-ink">
      <SiteHeader />
      <main>
        <Hero />
        <ProofRow />
        <CoachingSection />
        <AgentSection />
        <AssistantSection />
        <ClientsSection />
        <TrialStrip />
        <CoachesSection />
        <ClosingCta />
      </main>
      <SiteFooter />
    </div>
  );
}
